
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';

export function MissingTemplateError() {
  const navigate = useNavigate();
  
  return (
    <Alert variant="destructive">
      <AlertTriangle className="h-4 w-4" />
      <AlertTitle>Missing Template ID</AlertTitle>
      <AlertDescription>
        No template ID was provided. Please go back to the templates list and select a template.
      </AlertDescription>
      <div className="flex gap-2 mt-4">
        <Button variant="outline" onClick={() => navigate('/email-templates')}>
          Back to Templates
        </Button>
      </div>
    </Alert>
  );
}
